// extracted by mini-css-extract-plugin
export default {"menuLink":"styles_menuLink__SUwvj","menu":"styles_menu__uAmMQ"};